import { transactionPaymentActionTypes } from "../../actionTypes/transactions/transactionPayment.actionTypes";

const initialState = {
  loading: false,
  error: null,
};

const transactionPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case transactionPaymentActionTypes.START_GET_PAYMENT_PAGE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case transactionPaymentActionTypes.GET_PAYMENT_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case transactionPaymentActionTypes.GET_PAYMENT_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default transactionPaymentReducer;
